var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c("div", { staticClass: "download-fx-wallet flex-center" }, [
        _c("div", { staticClass: "download-fx-wallet-main" }, [
          _c("div", { staticClass: "download-fx-wallet-top" }, [
            _c("div", { staticClass: "download-fx-wallet-title" }, [
              _c("i", {
                staticClass: "icon icon-close",
                on: { click: _vm.onShowMessageBox },
              }),
            ]),
          ]),
          _c("div", { staticClass: "download-fx-wallet-content" }, [
            _c("div", { staticClass: "download-fx-wallet-qr" }, [
              _c("img", { attrs: { src: _vm.downloadQrImg, alt: "" } }),
            ]),
            _c("h6", [
              _vm._v(
                _vm._s(_vm.$t("common.downloadFxWallet.downloadFxWallet"))
              ),
            ]),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("common.downloadFxWallet.downloadFxWalletPlease"))
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }